/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Order extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Order;


// WEBPACK FOOTER //
// ./src/routes/order/index.js